import {
  CountryBean,
  DictionariesControllerApi,
  IabCategoryBean,
  LanguageBean,
  TimezoneBean
} from 'common/api/api'
import { BaseApi, configuration } from 'common/api/BaseApi'
import { processError } from 'common/api/fetch'

class DictionariesApi extends BaseApi {
  api: DictionariesControllerApi

  constructor() {
    super()
    this.api = new DictionariesControllerApi(configuration, configuration.basePath, this.fetch)
  }

  iabCategories(): Promise<Array<IabCategoryBean>> {
    return this.api
      .iabCategories()
      .then((cats) => {
        return Promise.resolve(cats)
      })
      .catch((err) => {
        return processError(err)
      })
  }

  countries(): Promise<Array<CountryBean>> {
    return this.api
      .countries()
      .then((countries) => {
        return Promise.resolve(countries)
      })
      .catch((err) => {
        return processError(err)
      })
  }

  languages(): Promise<Array<LanguageBean>> {
    return this.api
      .language()
      .then((list) => {
        return Promise.resolve(list)
      })
      .catch((err) => {
        return processError(err)
      })
  }

  timezones(): Promise<Array<TimezoneBean>> {
    return this.api
      .timezone()
      .then((timezones) => {
        return Promise.resolve(timezones)
      })
      .catch((err) => {
        return processError(err)
      })
  }
}

const dictionariesApi = new DictionariesApi()

export default dictionariesApi
